// @flow

// Wait a tick to get past the loading state
export default (ms?: number) =>
  new Promise<void>(resolve => setTimeout(resolve, ms));
